<template>
  <header>
    <h1><span class="logo-style">Kichwa</span>Code</h1>
    <nav class="nav-bar">
      <ul>
        <li><button class="button" v-if="isLogin"  v-on:click="clicked('/dashboard')" >Mi Panel</button></li>
        <li><button class="button" v-if="!isLogin"  v-on:click="clicked('/login')" >Iniciar Sesion</button></li>

      </ul>
    </nav>
    <nav
      class="mobile-nav"
      v-if="isActive"
      v-bind:class="{ navActive: isActive }"
    >
      <ul>
        <li><button class="button" v-if="isLogin"  v-on:click="clicked('/dashboard')" >Mi Panel</button></li>
        <li><button class="button" v-if="!isLogin"  v-on:click="clicked('/login')" >Iniciar Sesion</button></li>
      </ul>
    </nav>
    <div class="mobile-nav-toggler" @click="toggleNav()">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>

    </div>
  </header>
</template>
<script>
import store from "@/store";

export default {
  data() {
    return {
      isActive: false,
      isLogin:false,
    };
  },
  methods: {
    toggleNav() {
      this.isActive = !this.isActive;
    },
    clicked: function (path) {
      this.$router.push(path)
    }
  },
  created: function(){
    this.getUserLogin();
    this.isLogin = store.getters.isLogin;
  }

};
</script>
